const TRIGGER_PRODUCT_ID = 15448229052751;
const TARGET_PROP_KEY = '_widget_id';
const TARGET_PROP_VAL = 'bundle_step_2';
const TARGET_FAKE_CLASS = 'property-_widget_id:bundle_step_2';

const getItems = () => Rebuy?.SmartCart?.cart?.items || [];

const isTriggerItem = (it) => Number(it?.product_id) === TRIGGER_PRODUCT_ID;

const isTargetItem = (it) => {
  const byProp = it?.properties?.[TARGET_PROP_KEY] === TARGET_PROP_VAL;
  const byClass = String(it?.properties?.class_list || '')
    .split(/\s+/)
    .includes(TARGET_FAKE_CLASS);
  const match = byProp || byClass;
  if (match) return match;
};

function getTriggerCount(items) {
  const count = items.reduce((n, it) => n + (isTriggerItem(it) ? Number(it?.quantity || 1) : 0), 0);

  return count;
}

async function removeTargetsNow() {
  const items = getItems();
  const targets = items.filter(isTargetItem);

  if (!targets.length) return;

  for (const it of targets) {
    try {
      await Rebuy.SmartCart.removeItem(it);
    } catch (e) {
      console.warn('[rebuy] ⚠️ removeItem error', e, it);
    }
  }
}

let prevTriggerCount = null;
let debounceTimer = null;

function scheduleHandleCartChange() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(handleCartChange, 120);
}

async function handleCartChange() {
  const items = getItems();

  const currCount = getTriggerCount(items);

  if (prevTriggerCount === null) {
    prevTriggerCount = currCount;
    return;
  }

  if (currCount < prevTriggerCount) {
    await removeTargetsNow();
  }

  prevTriggerCount = currCount;
}

document.addEventListener('rebuy:ready', scheduleHandleCartChange);
document.addEventListener('rebuy:smartcart.show', scheduleHandleCartChange);
document.addEventListener('rebuy:cart.change', scheduleHandleCartChange);
